import React, { Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl,  mediaUrl} from'../Config/Config';
import axios from 'axios';
import { ShadowPicker } from "react-shadow-picker";
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class Add extends Component {
	
	fileObj = [];
    fileArray = [];
    imageArray = [];
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		this.state = {
			title:'',
			
			status:'A',
		    selectedFile: null,
			Loading:false,
			selectedvalue: '',
            selectedOption:{ value: 'active', label: 'Active'},
			selectedFileCount : 0,

			shadow: "",
			shadows: {
				shadowPluginOpenButton: "0px 2px 36px #0404052e",
				shadowPluginOpenButtonInset: "inset 5px 0px 5px 0px #3434372b",
				largeButton: "0 4px 18px 0 #0404052e",
				shadowButtonInset: "0 4px 18px 0 #0404052e",
				shadowDropdownMenu: "0px 12px 30px #0404052e",
				shadowDropdownMenuInset: "0px 12px 30px #0404052e",
				dashboardShadowGrid: "0 10px 21px 0 #0000001c",
				shadowDashboardGridInset: "0 10px 21px 0 #0000001c",
				dashboardShadowList: "0 21px 21px 0 #0000001c",
				shadowDashboardListInset: "0 21px 21px 0 #0000001c",
				shadowAISidebar: '1px 0px #0000000c',
				shadowAISidebarInset: 'inset 5px 0px 5px 0px #3434372b',
				shadowTopPopup: '1px 0px #0000000c',
				shadowTopPopupInset: '1px 0px #0000000c',
				shadowFormGroup: '0px 3px 21px 0px #9f99995c',
				shadowFormGroupInset: '1px 0px #0000000c',
				shadowLeftSidebar: "0px 3px 21px 0px #9f99995c",
				shadowLeftSidebarInset: "0px 3px 21px 0px #9f99995c",
				shadowRightSidebar: "0px 3px 21px 0px #9f99995c",
				shadowRightSidebarInset: "0px 3px 21px 0px #9f99995c",
				shadowSearchDropdown: "0px 40px 50px -40px #3434375E",
				shadowSearchDropdownInset: "inset 5px 0px 5px 0px #3434372b",
				shadowListRow: '0px 15px 10px -15px #0404052e',
				shadowTableRow: '0px 7px 8px -7px #0404052e',
				shadowPluginInsetLeft: "inset 15px 0 10px -10px #2727272b",
				shadowPluginInsetRight: "",
				shadowPluginInsetTop: "",
				shadowPluginInsetBottom: "",
				pluginShadow: "0px 24px 34px #0404052e",
				shadowInput: "5px 0px 5px 0px #3434372b",
				shadowText: "0 7px 10px -7px #04040422",
				textarea: "0 7px 10px -7px #04040422",				
				//sideMenu: "-2px 10px 15px #3434375e",
				//shortcutMenu: "0px 3px 21px 0px #9f99995c",
				// shadowPluginInset: "inset 5px 0px 15px 0 #3434372b",
				shadowMainAITextarea: "inset 5px 0px 5px 0px #3434372b",

			},
			activeShadowType: "largeButton",

			line_height    	: '1.5',
			pluginRadius    : '30',
			dropdownRadius  : '10',
			inputRadius    	: '10',
			textareaRadius  : '10',
			listRowRadius  : '10',
			dashboardGridRadius  : '10',
			dashboardListRadius  : '10',
			imageSliderRadius  : '10',
			formGroupRadius  : '10',
			st_aisidebar_width  : '',
			st_aisidebar_collapsed_width  : '',
			st_aisidebar_icon_width  : '',

			// fontDetails: [
			// 	{ index: 1, FontType: "primary", listName: "Primary", font_id : 55, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 2, FontType: "mainTab", listName: "Main Tab", font_id : 55, fontSize: "22", fontWeight: "600", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 3, FontType: "sideMenu", listName: "Side Menu", font_id : 55, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 4, FontType: "title", listName: "Title", font_id : 55, fontSize: "22", fontWeight: "800", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 5, FontType: "subTitle", listName: "Sub Title", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 6, FontType: "listFont", listName: "List Font", font_id : 55, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 7, FontType: "listTitleFont", listName: "List Title Font", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 8, FontType: "listSerialNoFont", listName: "List Serial No Font", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "1.5", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 9, FontType: "menuLogo", listName: "Menu Logo", font_id : 55, fontSize: "28", fontWeight: "700", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 10, FontType: "dashboardList", listName: "Dashboard List", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "1.5", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 11, FontType: "dashboardListCount", listName: "Dashboard List Count", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 12, FontType: "largebutton", listName: "Large Button", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "1.5", topSpace: "12", bottomSpace: "11", radius: "11" },
			// 	{ index: 13, FontType: "smallbutton", listName: "Small Button", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "1.5", topSpace: "8", bottomSpace: "3", radius: "11" },
			// 	{ index: 14, FontType: "pluginOpenButton", listName: "Plugin Open Button", font_id : 55, fontSize: "32", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "14", bottomSpace: "10", radius: "11" },
			// 	{ index: 15, FontType: "listStoreName", listName: "List Store Name", font_id : 55, fontSize: "22", fontWeight: "600", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 16, FontType: "detailProductDesc", listName: "Product Detail Desc", font_id : 55, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 17, FontType: "mainAISidebarChatSummaryTitle", listName: "AI Chat Summary Title", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 18, FontType: "mainAISidebarChatSummary", listName: "AI Chat Summary", font_id : 55, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 19, FontType: "mainAISidebarProfile", listName: "AI Profile Dropdown", font_id : 55, fontSize: "11", fontWeight: "500", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 20, FontType: "formLabel", listName: "Form Label", font_id : 55, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// ],


			fontDetails: [
				{ index: 1, FontType: "primary", listName: "Primary", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 2, FontType: "mainTab", listName: "Main Tab", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 3, FontType: "sideMenu", listName: "Side Menu", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 4, FontType: "title", listName: "Title", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 5, FontType: "subTitle", listName: "Sub Title", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 6, FontType: "listFont", listName: "List Font", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 7, FontType: "listTitleFont", listName: "List Title Font", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 8, FontType: "listSerialNoFont", listName: "List Serial No Font", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 9, FontType: "menuLogo", listName: "Menu Logo", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 10, FontType: "dashboardList", listName: "Dashboard List", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 11, FontType: "dashboardListCount", listName: "Dashboard List Count", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 12, FontType: "largebutton", listName: "Large Button", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 13, FontType: "smallbutton", listName: "Small Button", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 14, FontType: "pluginOpenButton", listName: "Plugin Open Button", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 15, FontType: "listStoreName", listName: "List Store Name", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 16, FontType: "detailProductDesc", listName: "Product Detail Desc", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 17, FontType: "mainAISidebarChatSummaryTitle", listName: "AI Chat Summary Title", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 18, FontType: "mainAISidebarChatSummary", listName: "AI Chat Summary", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 19, FontType: "mainAISidebarProfile", listName: "AI Profile Dropdown", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 20, FontType: "formLabel", listName: "Form Label", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 21, FontType: "formLabelFocused", listName: "Form Label Focused", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 22, FontType: "formInput", listName: "Form Input", font_id : 55, fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			],
			fonttype: [],
			selectedFont: "",
			selectedFontVariant: "",
			st_varient_id: [],
		};
		
	   this.handleInputChange = this.handleInputChange.bind(this);
	   this.handleChange = this.handleChange.bind(this);
    }
	

   handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
    }

     handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	componentDidMount() {
		document.title = PageTitle('Theme Add');

		var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id).then(res => {
			if(res.data.status == 'success'){
				this.setState({
					fonttype: res.data.fontlist
				}, () => {
					// 🔹 After fonts are loaded, preload variants for existing fontDetails
					this.state.fontDetails.forEach((font, idx) => {
						if (font.font_id) {
						this.preloadFontVariants(font.font_id, idx);
						}
					})
				})
			}
		});
    }
	preloadFontVariants = async (fontValue, idx) => {
		try {
		// Find label from fonttype list
		//const selectedFont = this.state.fonttype.find(f => f.value == fontValue);
		const selectedFont = this.state.fonttype.find(f => f.value.toString() === fontValue.toString());
		const fontLabel = selectedFont ? selectedFont.label : "";

		const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
			params: {
				id: fontValue,
  				...(fontLabel && { name: fontLabel }),
			},
		});

		if (response.data.variants) {
			let fontDetails = [...this.state.fontDetails];
			fontDetails[idx] = {
			...fontDetails[idx],
			variants: response.data.variants,
			};
			this.setState({ fontDetails });
		}
		} catch (error) {
		console.error("Error preloading font variants:", error);
		}
	};

	handleFormSubmit = () => {
		if(this.validateForm()){
			this.setState({Loading:true});
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};

			const formPayload = this.state;
			var qs = require('qs');
			var status = '';
			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
			status =formPayload.selectedOption.value;
			}else{
			status = formPayload.selectedvalue;
			}
			var admin_id = localStorage.getItem("admin_id");
			var postObject = {
				admin_id     	: admin_id,
				title    		: formPayload.title,
				line_height    	: formPayload.line_height,
				st_aisidebar_width: formPayload.st_aisidebar_width,
				st_aisidebar_collapsed_width: formPayload.st_aisidebar_collapsed_width,
				st_aisidebar_icon_width: formPayload.st_aisidebar_icon_width,
				pluginRadius    : formPayload.pluginRadius,
				dropdownRadius  : formPayload.dropdownRadius,
				inputRadius    	: formPayload.inputRadius,
				textareaRadius  : formPayload.textareaRadius,
				listRowRadius  : formPayload.listRowRadius,
				dashboardGridRadius  : formPayload.dashboardGridRadius,
				dashboardListRadius  : formPayload.dashboardListRadius,
				imageSliderRadius  : formPayload.imageSliderRadius,
				formGroupRadius  : formPayload.formGroupRadius,
				fontDetails:JSON.stringify(formPayload.fontDetails),
				shadow: JSON.stringify(this.state.shadows),
			};

			let formData = new FormData();
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}
									
			axios.post(apiUrl+"thememanagement/add",formData,config).then(res => {
				if(res.data.status === "success"){
					this.setState({ Loading: false });
					$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');

					scrollToTop();
							setTimeout(
							function() {
								$('.success_message').html('');
								this.props.navigate('/themes');
							}
							.bind(this),
							3000
							);
				} else {
					this.setState({ Loading: false });
					$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
					scrollToTop();
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
				}
			});
		}
	}

	validateForm() {
		const {title, fontDetails, st_aisidebar_width, st_aisidebar_icon_width, st_aisidebar_collapsed_width} = this.state;

		let errors = 0;
		if (!title) {
			errors++;
			$('.errortitle').html('<span class="errorspan">Please fill the field</span>');
		}else if(title){
			$('.errortitle').html('');
		}
		if (!st_aisidebar_width) {
			errors++;
			$('.errorsst_aisidebar_width').html('<span class="errorspan">Please fill the field</span>');
		}else if(st_aisidebar_width){
			$('.errorsst_aisidebar_width').html('');
		}
		if (!st_aisidebar_icon_width) {
			errors++;
			$('.errorsst_aisidebar_icon_width').html('<span class="errorspan">Please fill the field</span>');
		}else if(st_aisidebar_icon_width){
			$('.errorsst_aisidebar_icon_width').html('');
		}
		if (!st_aisidebar_collapsed_width) {
			errors++;
			$('.errorsst_aisidebar_collapsed_width').html('<span class="errorspan">Please fill the field</span>');
		}else if(st_aisidebar_collapsed_width){
			$('.errorsst_aisidebar_collapsed_width').html('');
		}

		// Font details validation
		fontDetails.forEach((font, idx) => {
			// Reset previous errors
			$(`.errorfile${idx}`).html('');
			$(`.fontVariantError${idx}`).html('');
			$(`.fontFamilyError${idx}`).html('');
			$(`.fontSizeError${idx}`).html('');
			$(`.letterSpacingError${idx}`).html('');
			$(`.topSpaceError${idx}`).html('');
			$(`.bottomSpaceError${idx}`).html('');
			$(`.radiusError${idx}`).html('');		

			if (!font.font_id || font.font_id === "") {
				errors++;
				$(`.fontFamilyError${idx}`).html('<span class="errorspan">Select a font family</span>');
			}
			if (!font.fontWeight || font.fontWeight === "") {
				errors++;
				$(`.fontVariantError${idx}`).html('<span class="errorspan">Select a font variant</span>');
			}
			if (!font.fontSize || isNaN(font.fontSize)) {
				errors++;
				$(`.fontSizeError${idx}`).html('<span class="errorspan">Enter valid font size</span>');
			}
			if (font.letterSpacing === "" || isNaN(font.letterSpacing)) {
				errors++;
				$(`.letterSpacingError${idx}`).html('<span class="errorspan">Enter valid letter spacing</span>');
			}			

			if (["smallbutton", "largebutton", "pluginOpenButton"].includes(font.FontType)) {
				if (!font.topSpace || isNaN(font.topSpace)) {
					errors++;
					$(`.topSpaceError${idx}`).html('<span class="errorspan">Enter valid top space</span>');
				}
				if (!font.bottomSpace || isNaN(font.bottomSpace)) {
					errors++;
					$(`.bottomSpaceError${idx}`).html('<span class="errorspan">Enter valid bottom space</span>');
				}
				if (!font.radius || isNaN(font.radius)) {
					errors++;
					$(`.radiusError${idx}`).html('<span class="errorspan">Enter valid radius</span>');
				}
			}
		});

	

		if(errors>0) {
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
		else {
			return true;
		}
    }

    componentWillReceiveProps(Props){

		if(Props.themeadd !== this.props.themeadd){
    		if(Object.keys(Props.themeadd).length > 0){
				this.setState({Loading:false});
				if(Props.themeadd[0].status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+Props.themeadd[0].message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html('');
						this.props.navigate('/themes');
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+Props.themeadd[0].message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
    		}
    	}
    }

	/**Shadow start */
	handleSubmit = () => {
		const popup = document.querySelector(".shadow-input-popup-action");
		if (popup) {
			popup.classList.remove("show");
		}
	};

	confirmPopup = (type) => {
		this.setState({ activeShadowType: type });
		$(".shadow-input-popup-action").addClass("show");
	};
 	handleShadowChange = (value) => {
		this.setState((prevState) => ({
		shadows: {
			...prevState.shadows,
			[this.state.activeShadowType]: value,
		},
		}));
	};

	handleCancel = () => {
		const popup = document.querySelector(".shadow-input-popup-action");
		if (popup) {
			popup.classList.remove("show");
		}
	};

	labelFor = (key) => {
		const labels = {
			shadowPluginOpenButton: "Open Button Shadow",
			shadowPluginOpenButtonInset: "Open Button Inset Shadow",
			largeButton: "Button Shadow",
			shadowButtonInset: "Button Inset Shadow",
			shadowDropdownMenu: "Dropdown Shadow (Bell notification, Group menu in listing screen)",
			shadowDropdownMenuInset: "Dropdown Inset Shadow (Bell notification, Group menu in listing screen)",
			dashboardShadowGrid: "Dashboard Grid Shadow",
			shadowDashboardGridInset: "Dashboard Grid Inset Shadow",
			dashboardShadowList: "Dashboard List Shadow",
			shadowDashboardListInset: "Dashboard List Inset Shadow",
			shadowAISidebar: "AI Sidebar Shadow",
			shadowAISidebarInset: "AI Sidebar Inset Shadow",
			shadowTopPopup: "Top Popup Shadow",
			shadowTopPopupInset: "Top Popup Inset Shadow",
			shadowFormGroup: "Form Group Shadow",
			shadowFormGroupInset: "Form Group Inset Shadow",
			shadowLeftSidebar: "Left Sidebar Shadow (Side menu)",
			shadowLeftSidebarInset: "Left Sidebar Inset Shadow (Side menu)",
			shadowRightSidebar: "Right Sidebar Shadow (Chat window)",
			shadowRightSidebarInset: "Right Sidebar Inset Shadow (Chat window)",
			shadowSearchDropdown: "Search Dropdown Shadow",
			shadowSearchDropdownInset: "Search Dropdown Inset Shadow",
			shadowListRow: "List Shadow",
			shadowTableRow: "Table Shadow",
			shadowPluginInsetLeft: 'Plugin Inside Left Shadow',
			shadowPluginInsetRight: 'Plugin Inside Right Shadow',
			shadowPluginInsetTop: 'Plugin Inside Top Shadow',
			shadowPluginInsetBottom: 'Plugin Inside Bottom Shadow',
			pluginShadow: "Plugin Shadow",
			shadowInput: "Input Box Shadow",
			shadowText: "Text Shadow (Result)",
			textarea: "Textarea Shadow (Invite friend page textarea)",			
			//sideMenu: "Sidemenu Shadow",
			//shortcutMenu: "Shortcut Menu Shadow (Shotcut menu, AI screen textarea)",
			//shadowPluginInset: "Plugin Inset Shadow",
			shadowMainAITextarea: "AI Screen Textarea Shadow",
		};
		return labels[key] || key;
	};

	handleInputChangeShadows = (type, value) => {
		this.setState((prevState) => ({
		shadows: {
			...prevState.shadows,
			[type]: value,
		},
		}));
	};
	/**Shadow end */

	/**Font management start */
	handleFileChangeVarients = async (e, idx, fontLabel, fontValue) => {
		let font_file = `font_file${idx}`;
		let fontDetails = [...this.state.fontDetails];

		fontDetails[idx] = {
		...fontDetails[idx],
		fontWeight: e.target.value,
		};
		fontDetails[e.target.dataset.id]["varient_id"] = idx;
		fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
		let selectedFont = e.target.name;
		this.setState({ fontDetails }, () => {
		console.log(this.state.fontDetails, "Updated fontDetails");
		});
	};
	addMoreFunc = (e) => {	
		return this.state.fontDetails.map((val, idx) => {
			
			let FontType = `FontType${idx}`,
			fontWeight = `fontWeight${idx}`,
			FontSize = `FontSize${idx}`,
			letterSpacing = `letterSpacing${idx}`,
			lineHeight = `lineHeight${idx}`,
			TopSpace = `TopSpace${idx}`,
			BottomSpace = `BottomSpace${idx}`,
			radius = `radius${idx}`,
			errorfile = `errorfile${idx}`;
			return ( <>
			<div className="form-row mb-0" key={val.index}>
					<div className='form-left'>			
					<div className="form-group"  >					
						<h4 className='fs-5'>
							{/* Apply font : */}

							{/* Font Apply to {this.Capitalize(val.FontType)} */}
							{(val.listName)} :
						
							</h4>					
						<div>{val.FontTypeCheck}</div>
					</div>
					</div>
				</div>
				<div className="form-row mb-5" key={val.index}>	
					{this.varientField(val.font_id, val.fontFamily, val.FontType,idx,val,val.index)}
				</div>
			</>
			);
		});
	}

	// varientField = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
	// 	console.log(FontType);
		
	// 	//console.log('done');
	// 	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	// 	id: index,
	// 	name: fonttype,
	// 	}));
	// 	// Dynamically create select list
	// 	let fonts = [];
	// 	fontArray.map(item =>
	// 		fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type }),
	// 	);

	// 	//console.log(fontArray);

	// 	let fontWeight = `fontWeight${idx}`,
	// 	FontSize = `FontSize${idx}`,
	// 	FontIndId = `FontId${idx}`,
	// 	letterSpacing = `letterSpacing${idx}`,
	// 	lineHeight = `lineHeight${idx}`,
	// 	TopSpace = `TopSpace${idx}`,
	// 	BottomSpace = `BottomSpace${idx}`,
	// 	radius = `radius${idx}`,
	// 	fontVariantError = `fontVariantError${idx}`,
	// 	fontFamilyError = `fontFamilyError${idx}`,
	// 	fontSizeError = `fontSizeError${idx}`,
	// 	letterSpacingError = `letterSpacingError${idx}`,
	// 	topSpaceError = `topSpaceError${idx}`,
	// 	bottomSpaceError = `bottomSpaceError${idx}`,
	// 	radiusError = `radiusError${idx}`,
	// 	errorfile = `errorfile${idx}`
	// 	//if(FontType !=='smallButton' && FontType!=='largeButton'){
	// 	return(
	// 		<>
	// 		<div className="form-left">
	// 			<div className="form-group">
	// 				<label>Font Family  :</label>
	// 				<div>																						
	// 					<select name="font_id" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx,selIndex)}>

	// 					<option value="" className="fontFamilyId" > Select Font</option>						
	// 					{fonts.map((option) => (
	// 					<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
	// 						{option.label}
	// 					</option>
	// 					))}
	// 					</select>	
	// 					<div className={fontFamilyError}></div> 						
	// 				</div>
	// 			</div>	
	// 		</div>
	// 		<div className="form-right">
	// 			<div className="form-group">
	// 				<label>Font Variant :</label>
	// 				<div>
	// 					 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>

	// 					<option value="" className="fontVarientName" > Select Variant</option>
	// 					<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
	// 					<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
	// 					<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
	// 					<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
	// 					<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
	// 					<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
	// 					<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
	// 					<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
										
	// 					</select>	 


															
	// 					<div className={fontVariantError}></div> 
	// 				</div>
	// 			</div>	
	// 		</div>	
	// 		<div className="form-left">
	// 			<div className="form-group">
	// 				<label>Font Size  :</label>
	// 				<div>
	// 					<input type="text" name="fontSize" 
	// 					onChange={(e) => this.handleFileChange(e, idx)} 
	// 					//onChange={this.onFileChange}
	// 					value={val.fontSize}

	// 					data-id={idx}
	// 					id={FontSize}    /> 
									
	// 					<div className={fontSizeError}></div> 
	// 				</div>
	// 			</div>	
	// 		</div>
	// 		<div className="form-right">
	// 			<div className="form-group">
	// 				<label>Letter Spacing  :</label>
	// 				<div>
	// 					<input type="text" name="letterSpacing" 
	// 					onChange={(e) => this.handleFileChange(e, idx)} 
	// 					//onChange={this.onFileChange}
	// 					value={val.letterSpacing}

	// 					data-id={idx}
	// 					id={letterSpacing}    /> 
									
	// 					<div className={letterSpacingError}></div> 
	// 				</div>
	// 			</div>	
	// 		</div>
	// 		{
	// 		(FontType =='smallbutton' || FontType=='largebutton' || FontType == 'pluginOpenButton') ?
	// 			<>
	// 			<div className="form-left">
	// 				<div className="form-group">
	// 					<label>Top Space :</label>
	// 					<div>
	// 						<input type="text" name="topSpace" 
	// 						onChange={(e) => this.handleFileChange(e, idx)} 
	// 						value={val.topSpace}
	// 						data-id={idx}
	// 						id={TopSpace}    /> 
										
	// 						<div className={topSpaceError}></div> 
	// 					</div>
	// 				</div>	
	// 			</div>
				
	// 			<div className="form-right">
	// 				<div className="form-group">
	// 					<label>Bottom Space :</label>
	// 					<div>
	// 						<input type="text" name="bottomSpace" 
	// 						onChange={(e) => this.handleFileChange(e, idx)} 
	// 						value={val.bottomSpace}
	// 						data-id={idx}
	// 						id={BottomSpace}    /> 									
	// 						<div className={bottomSpaceError}></div> 
	// 					</div>
	// 				</div>	
	// 			</div>					
	// 			</>
	// 		: ''
	// 		}
	// 		{
	// 		(FontType =='smallbutton' || FontType=='largebutton' || FontType == 'pluginOpenButton') ?
	// 			<>					
	// 			<div className="form-left">
	// 				<div className="form-group">
	// 					<label>Radius :</label>
	// 					<div>
	// 						<input type="text" name="radius" 
	// 						onChange={(e) => this.handleFileChange(e, idx)} 
	// 						value={val.radius}
	// 						data-id={idx}
	// 						id={radius}    /> 	
	// 						<div className={radiusError}></div> 
	// 					</div>
	// 				</div>	
	// 			</div>
	// 			</>
	// 		: ''
	// 		}
	// 	</>);
	// }
	varientField = (FontId, FontFamily, FontType, idx, val, selIndex) => {
		const fontArray = this.state.fonttype.map((fonttype, index) => ({
			id: index,
			name: fonttype,
		}));

		console.log(fontArray, "this is for font array");
		// Dynamically create select list
		let fonts = [];
		fontArray.map((item) =>
		fonts.push({
			label: item.name.label,
			value: item.name.value,
			fontStyles: item.name.font_style,
			typeIs: item.name.type,
			type: item.name.type,
		})
		);

		let fontWeight = `fontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		FontIndId = `FontId${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		radius = `radius${idx}`,
		fontFamilyError = `fontFamilyError${idx}`,
		fontVariantError = `fontVariantError${idx}`,
		fontSizeError = `fontSizeError${idx}`,
		letterSpacingError = `letterSpacingError${idx}`,
		topSpaceError = `topSpaceError${idx}`,
		bottomSpaceError = `bottomSpaceError${idx}`,
		radiusError = `radiusError${idx}`
		;
		//if(FontType !=='smallButton' && FontType!=='largeButton'){
		return (
		<>
			<div className="form-left">
			<div className="form-group">
				<label>Font Family :</label>
				<div>
				<select
					name="font_id"
					className="form-control"
					id={FontType}
					data-id={idx}
					value={val.font_id?.toString() || ""}
					onChange={(e) => {
					const selectedValue = e.target.value;
					const selectedOption = fonts.find(
						(option) => option.value === selectedValue
					);
					this.handleFileChange(
						e,
						idx,
						selectedOption?.label,
						selectedOption?.value
					);
					}}
				>
					<option value="">Select Font</option>

					<optgroup label="System Fonts">
					{fonts
						.filter((f) => f.type === "system_font")
						.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
						))}
					</optgroup>
					<optgroup label="Google Fonts">
					{fonts
						.filter((f) => f.type === "google_font")
						.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
						))}
					</optgroup>
					{console.log(fonts, "this is for fonts label")}
					<optgroup label="Custom Fonts">
					{fonts
						.filter((f) => f.type === "normal_font")
						.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
						))}
					</optgroup>
				</select>
				<div className={fontFamilyError}></div>
				</div>
			</div>
			</div>
			<div className="form-right">
			<div className="form-group">
				<label>Font Variant :</label>
				<div>
				<select
					name="fontWeight"
					className="form-control"
					id={FontType}
					data-id={idx}
					onChange={(e) => this.handleFileChangeVarients(e, idx)}
				>
					<option value="" className="fontVarientName">
					Select Variant
					</option>
					{console.log(this.state.fontDetails, "this is fontsdetails")}
					{this.state.fontDetails[idx]?.variants?.map((variant) => (
					<option
						key={variant.value}
						value={variant.value || val.fontWeight}
						selected={val.fontWeight == variant.value ? true : false}
					>
						{variant.label} {variant.value}
					</option>
					))}
				</select>

				<div className={fontVariantError}></div>
				</div>
			</div>
			</div>

			<div className="form-left">
			<div className="form-group">
				<label>Font Size :</label>
				<div>
				<input
					type="text"
					name="fontSize"
					onChange={(e) => this.handleFileChange(e, idx)}
					//onChange={this.onFileChange}
					value={val.fontSize}
					data-id={idx}
					id={FontSize}
				/>

				<div className={fontSizeError}></div>
				</div>
			</div>
			</div>
			<div className="form-right">
			<div className="form-group">
				<label>Letter Spacing :</label>
				<div>
				<input
					type="text"
					name="letterSpacing"
					onChange={(e) => this.handleFileChange(e, idx)}
					//onChange={this.onFileChange}
					value={val.letterSpacing}
					data-id={idx}
					id={letterSpacing}
				/>

				<div className={letterSpacingError}></div>
				</div>
			</div>
			</div>
			{console.log(FontType, "thi is fonttype")}
			{FontType == "smallbutton" ||
			FontType == "largebutton" ||
			FontType == "pluginOpenButton" ? (
			<>
				<div className="form-left">
				<div className="form-group">
					<label>Top Space :</label>
					<div>
					<input
						type="text"
						name="topSpace"
						onChange={(e) => this.handleFileChange(e, idx)}
						value={val.topSpace}
						data-id={idx}
						id={TopSpace}
					/>

					<div className={topSpaceError}></div>
					</div>
				</div>
				</div>
				<div className="form-right">
				<div className="form-group">
					<label>Bottom Space :</label>
					<div>
					<input
						type="text"
						name="bottomSpace"
						onChange={(e) => this.handleFileChange(e, idx)}
						value={val.bottomSpace}
						data-id={idx}
						id={BottomSpace}
					/>
					<div className={bottomSpaceError}></div>
					</div>
				</div>
				</div>
				<div className="form-left">
				<div className="form-group">
					<label>Radius :</label>
					<div>
					<input
						type="text"
						name="radius"
						onChange={(e) => this.handleFileChange(e, idx)}
						value={val.radius}
						data-id={idx}
						id={radius}
					/>

					<div className={radiusError}></div>
					</div>
				</div>
				</div>
			</>
			) : (
			""
			)}
		</>
		);
	};

	// handleFileChange = (e, idx) => {
	// 	let	font_file = `font_file${idx}`;
	// 	let fontDetails = [...this.state.fontDetails];
	// 	fontDetails[e.target.dataset.id]['varient_id'] = idx;	
	// 	fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
	// 	this.setState({
	// 		fontDetails: 			  
	// 		fontDetails
	// 	});

	// }; 

	handleFileChange = async (e, idx, fontLabel, fontValue) => {
		let font_file = `font_file${idx}`;
		let fontDetails = [...this.state.fontDetails];
		fontDetails[e.target.dataset.id]["varient_id"] = idx;
		fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
		let selectedFont = e.target.name;
		if (fontValue) {
		try {
			const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
			params: {
				id: fontValue,
				name: fontLabel,
			},
			});
			if (response.data.variants) {
			fontDetails[idx] = {
				...fontDetails[idx],
				variants: response.data.variants,
			};
			console.log(response.data.variants, "this is fortvarientrecords");
			}
		} catch (error) {
			console.error("Error fetching font variants:", error);
		}
		}

		this.setState({ fontDetails }, () => {
		console.log(this.state.fontDetails, "Updated fontDetails");
		});
	};
	/**Font management end */

  	render() {
  	const {selectedOption} = this.state;

    return (
      <div className="wrapper"> 
	 	<Header />
    	<MenuSidebar currentpage="themes" />  
		<div className="content">	
			<div className="content-wrapper">
				<div class="content-wrapper-before"></div>
				<div className="form-wrapper leaa-admin-head card">
					<div className="success_message"></div>
					<div>
						<a className="btn" href="/themes">Back</a>
					</div>
					<div className="title">
						<h4>Add Theme</h4>
					</div>
					<form className="login" id="login" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>			
						<div className="form-row">
							<div className='form-left'>
								<div className="form-group">
									<label>Template Name<span class="required" style={{ color: "red" }} > * </span></label>
									<input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title} autoComplete="off" />
									<div className="errortitle"></div>
								</div>
							</div>
							<div className='form-right'>
								<div className="form-group">					
									<label>Status</label>
									<Select 
									value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
									options={lang.common.status_option} 
									onChange={this.handleChange}
									/>
								</div>
							</div>
						</div>

						<div className="title">
							<h4>Ai Sidebar Management</h4>
						</div> 		   
						<div className="form-row">
							<div className="form-left">
								<div className="form-group">
									<label>Sidebar Expended size (px)<span class="required" style={{ color: "red" }} > * </span></label>
									<input type="text" className="form-control" name="st_aisidebar_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_width}/>
									<div className="errorsst_aisidebar_width"></div>
								</div>						
										
								<div className="form-group">
									<label>Sidebar Icon Size (px)<span class="required" style={{ color: "red" }} > * </span></label>
									<input type="text" className="form-control" name="st_aisidebar_icon_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_icon_width}/>
									<div className="errorsst_aisidebar_icon_width"></div>
								</div>			
							</div>	
							<div className="form-right">
								<div className="form-group">
									<label>Sidebar Collapsed size (px)<span class="required" style={{ color: "red" }} > * </span></label>
									<input type="text" className="form-control" name="st_aisidebar_collapsed_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_collapsed_width}/>
									<div className="errorsst_aisidebar_collapsed_width"></div>
								</div>	
																	
							</div>	
							
						</div>

						<div className="title">
							<h4>Radius Management</h4>
						</div> 
						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">					
									<label>Plugin Radius (px):</label>
									<input type="text" className="form-control" name="pluginRadius"  onChange={this.handleInputChange}  value={this.state.pluginRadius} />
									<div className="errorpluginRadius"></div>
								</div>
								<div className="form-group">
									<label>Input Box Radius (px):</label>
									<input type="text" className="form-control" name="inputRadius"  onChange={this.handleInputChange} value={this.state.inputRadius}/>
									<div className="errorinputRadius"></div>
								</div>	
								<div className="form-group">
									<label>Dashboard Grid Radius (px):</label>
									<input type="text" className="form-control" name="dashboardGridRadius"  onChange={this.handleInputChange} value={this.state.dashboardGridRadius}/>
									<div className="errordashboardGridRadius"></div>
								</div>	
								<div className="form-group">
									<label>List Row Radius (px):</label>
									<input type="text" className="form-control" name="listRowRadius"  onChange={this.handleInputChange} value={this.state.listRowRadius}/>
									<div className="errorlistRowRadius"></div>
								</div>	
								<div className="form-group">
									<label>Form Group Radius (px):</label>
									<input type="text" className="form-control" name="formGroupRadius"  onChange={this.handleInputChange} value={this.state.formGroupRadius}/>
									<div className="errorformGroupRadius"></div>
								</div>	
								
							</div>
							<div className="form-right">					
								<div className="form-group">
									<label>Dropdown Radius (Bell notification, Grouping menu listing) (px):</label>
									<input type="text" className="form-control" name="dropdownRadius"  onChange={this.handleInputChange}  value={this.state.dropdownRadius} />
									<div className="errordropdownRadius"></div>
								</div>
								<div className="form-group">
									<label>Textarea Radius (AI screen textarea, Invite friend textarea) (px):</label>
									<input type="text" className="form-control" name="textareaRadius"  onChange={this.handleInputChange} value={this.state.textareaRadius}/>
									<div className="errortextareaRadius"></div>
								</div>
								<div className="form-group">
									<label>Dashboard List Radius (px):</label>
									<input type="text" className="form-control" name="dashboardListRadius"  onChange={this.handleInputChange} value={this.state.dashboardListRadius}/>
									<div className="errordashboardListRadius"></div>
								</div>
								<div className="form-group">
									<label>Image Slider Radius (px):</label>
									<input type="text" className="form-control" name="imageSliderRadius"  onChange={this.handleInputChange} value={this.state.imageSliderRadius}/>
									<div className="errorimageSliderRadius"></div>
								</div>
							</div>
						</div>

						{/* Shadow Management Start */}
						<div className="title">
							<h4>Shadow Management</h4>
						</div>

						<div className="form-row">
							<div className="shadow-input-popup-action">
								<span
								className="shadow-input-close"
								onClick={this.handleCancel}
								>
								X
								</span>
								<div className="title">
									<h4 style={{ fontSize: "30px" }}>
										{this.labelFor(this.state.activeShadowType)}
									</h4>
								</div>
								<div className="shadow-picker-container d-flex w-100 justify-content-between">
									<ShadowPicker
										value={
										this.state.shadows[this.state.activeShadowType] ||
										""
										}
										onChange={(value) => this.handleShadowChange(value)}
										className="shadow-picker"
									/>

									<div
										className="shadow-box"
										style={{
										boxShadow:
											this.state.shadows[this.state.activeShadowType] ||
											"none",
										}}
									></div>
								</div>
								<div className="d-flex w-100 justify-content-end gap-2 mt-5">
									<button type="button" className="shadow-btn" onClick={this.handleSubmit}>
										Save
									</button>
								</div>
							</div>
						</div>

						<div className="form-row">
							{Object.entries(this.state.shadows).map(([key, value]) => (
								<div className="form-left" key={key}>
									<div className="form-group admin-panel-btn">
										<label>{this.labelFor(key)}:</label>
										<input
										value={value}
										type="text"
										autoComplete="off"
										className="form-control"
										style={{ width: "85%" }}
										onChange={(e) =>
											this.handleInputChangeShadows(key, e.target.value)
										}
										/>
										<button
										type="button"
										onClick={() => this.confirmPopup(key)}
										style={{
											color: "white",
											padding: "14px",
											minWidth: "47px",
											height: "48px",
											backgroundColor: "rgb(5, 31, 58)",
											borderRadius: "0px 5px 5px 0px",
										}}
										>
										<i>
											<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="#fff"
											viewBox="32 -0.03 543.87 512.03"
											>
											<path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path>
											</svg>
										</i>
										</button>
									</div>
								</div>
							))}
						</div>
						{/* Shadow Management End */}

						{/* Font Management End */}
						<div className="title">
							<h4>Font Management</h4>
						</div> 
						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">
									<label>Line Height</label>
									<input type="text" className="form-control" name="line_height" onChange={this.handleInputChange}  value={this.state.line_height}/>
									<div className="errorline_height"></div>
								</div>
							</div>
						</div>
					
						{this.addMoreFunc()}	
						{/* Font Management End */}
								
						<div className='white-space-110px'></div>
					
						<div className="btn-group export">	
							<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true && <span className="load-data"></span> }Submit
							</button>
						</div>
					</form>
				</div>
			</div>	
		</div>
    </div>
    );
  }
}



export default withRouter(Add);